import { css } from 'emotion'

export const MembersMainStyles = css`
  > header {
    display: flex;
    margin-bottom: 16px;
    justify-content: flex-end;
  }
`
